import React, { useState, useEffect, useCallback } from 'react';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import PropTypes from 'prop-types';

import { thousandFormat2 } from '../../../../Utils/Functions';
import { empty } from '../../../../Assets/js/constant';
import appdata from '../../../../Services/appdata';

const tableBorder = {
  borderBottom: '1px solid lightgrey',
  borderRight: '1px solid lightgrey',
  height: 20,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const BottomChart = ({
  detailData,
  handleFilter,
  selectedOption,
  showPercent,
  profitName: initialProfitName,
  pprofitName: initialPProfitName,
}) => {
  const [resize, setResize] = useState(false);
  const [selectedIdRects, setSelectedIdRects] = useState([]);
  const [pageOffset, setPageOffset] = useState(0);
  const [tableStructure, setTableStructure] = useState([]);
  const [profit, setProfit] = useState({});
  const [pprofit, setPProfit] = useState({});
  const [profitName, setProfitName] = useState(initialProfitName);
  const [pprofitName, setPProfitName] = useState(initialPProfitName);

  // Resize handler
  const onResize = useCallback(() => setResize((r) => !r), []);

  // Prepare data
  const prepareData = useCallback(() => {
    let profit = {
      incomeActual: 0,
      incomeBudget: 0,
      incomeForecast: 0,
      incomeActualVsBudgetVariance: 0,
      incomeActualVsForecastVariance: 0,
      incomeYTDActual: 0,
      incomeYTDBudget: 0,
      incomeYTDForecast: 0,
      incomeYTDActualVsBudgetVariance: 0,
      incomeYTDActualVsForecastVariance: 0,
      expenseActual: 0,
      expenseBudget: 0,
      expenseForecast: 0,
      expenseActualVsBudgetVariance: 0,
      expenseActualVsForecastVariance: 0,
      expenseYTDActual: 0,
      expenseYTDBudget: 0,
      expenseYTDForecast: 0,
      expenseYTDActualVsBudgetVariance: 0,
      expenseYTDActualVsForecastVariance: 0,
    };
    let pprofit = {};
    let alreadyIncluded = {
      Actual: 0,
      Budget: 0,
      Forecast: 0,
      ActualVsBudgetVariance: 0,
      ActualVsForecastVariance: 0,
      YTDActual: 0,
      YTDBudget: 0,
      YTDForecast: 0,
      YTDActualVsBudgetVariance: 0,
      YTDActualVsForecastVariance: 0,
    };
    let filterStructure = [];
    let tableStructure = [];
    if (appdata.getItem('tableStructure'))
      tableStructure = appdata.getItem('tableStructure');
    
    if (detailData.length > 0) {
      tableStructure.forEach((structure) => {
        let filterAccount = structure;
        let subAccounts = structure.subItems;
        let removeAccounts = [];
        if (structure.total) {
          structure.subItems.forEach((item) => {
            let account = detailData.find(
              (account) => account.IncomeStatementCategory === item.content,
            );
            if (account) {
              item.Actual = parseFloat(account.Actual);
              item.Budget = parseFloat(account.Budget);
              item.Forecast = parseFloat(account.Forecast);
              item.ActualVsBudgetVariance = parseFloat(
                account.ActualVsBudgetVariance,
              );
              item.ActualVsForecastVariance = parseFloat(
                account.ActualVsForecastVariance,
              );
              item.YTDActual = parseFloat(account.YTDActual);
              item.YTDBudget = parseFloat(account.YTDBudget);
              item.YTDForecast = parseFloat(account.YTDForecast);
              item.YTDActualVsBudgetVariance = parseFloat(
                account.YTDActualVsBudgetVariance,
              );
              item.YTDActualVsForecastVariance = parseFloat(
                account.YTDActualVsForecastVariance,
              );
              item.Income = account.Income;
            } else removeAccounts.push(item);
          });
          subAccounts = subAccounts.filter(function (e) {
            return !removeAccounts.some(function (s) {
              return s.content === e.content;
            });
          });
          filterAccount.subItems = subAccounts;
          if (subAccounts.length > 0) filterStructure.push(filterAccount);
        } else filterStructure.push(structure);
      });

      filterStructure.map((structure) => {
        if (structure.total) {
          structure.totalActual = 0;
          structure.totalBudget = 0;
          structure.totalForecast = 0;
          structure.totalActualVsForecastVariance = 0;
          structure.totalActualVsBudgetVariance = 0;
          structure.totalYTDActual = 0;
          structure.totalYTDBudget = 0;
          structure.totalYTDForecast = 0;
          structure.totalYTDActualVsBudgetVariance = 0;
          structure.totalYTDActualVsForecastVariance = 0;
          if (structure.income) {
            structure.subItems.map((item) => {
              if (item.Income) {
                structure.totalActual += item.Actual;
                structure.totalBudget += item.Budget;
                structure.totalForecast += item.Forecast;
                structure.totalYTDActual += item.YTDActual;
                structure.totalYTDBudget += item.YTDBudget;
                structure.totalYTDForecast += item.YTDForecast;
              } else {
                item.Actual = 0 - item.Actual;
                item.Budget = 0 - item.Budget;
                item.Forecast = 0 - item.Forecast;
                item.YTDActual = 0 - item.YTDActual;
                item.YTDBudget = 0 - item.YTDBudget;
                item.YTDForecast = 0 - item.YTDForecast;
                structure.totalActual += item.Actual;
                structure.totalBudget += item.Budget;
                structure.totalForecast += item.Forecast;
                structure.totalYTDActual += item.YTDActual;
                structure.totalYTDBudget += item.YTDBudget;
                structure.totalYTDForecast += item.YTDForecast;
              }
              return item;
            });
            structure.totalActualVsForecastVariance =
              structure.totalActual - structure.totalForecast;
            structure.totalActualVsBudgetVariance =
              structure.totalActual - structure.totalBudget;
            structure.totalYTDActualVsForecastVariance =
              structure.totalYTDActual - structure.totalYTDForecast;
            structure.totalYTDActualVsBudgetVariance =
              structure.totalYTDActual - structure.totalYTDBudget;
          } else {
            structure.subItems.map((item) => {
              if (item.Income) {
                item.Actual = 0 - item.Actual;
                item.Budget = 0 - item.Budget;
                item.Forecast = 0 - item.Forecast;
                item.YTDActual = 0 - item.YTDActual;
                item.YTDBudget = 0 - item.YTDBudget;
                item.YTDForecast = 0 - item.YTDForecast;
                structure.totalActual += item.Actual;
                structure.totalBudget += item.Budget;
                structure.totalForecast += item.Forecast;
                structure.totalYTDActual += item.YTDActual;
                structure.totalYTDBudget += item.YTDBudget;
                structure.totalYTDForecast += item.YTDForecast;
              } else {
                structure.totalActual += item.Actual;
                structure.totalBudget += item.Budget;
                structure.totalForecast += item.Forecast;
                structure.totalYTDActual += item.YTDActual;
                structure.totalYTDBudget += item.YTDBudget;
                structure.totalYTDForecast += item.YTDForecast;
              }
              return item;
            });
            structure.totalActualVsForecastVariance =
              structure.totalForecast - structure.totalActual;
            structure.totalActualVsBudgetVariance =
              structure.totalBudget - structure.totalActual;
            structure.totalYTDActualVsForecastVariance =
              structure.totalYTDForecast - structure.totalYTDActual;
            structure.totalYTDActualVsBudgetVariance =
              structure.totalYTDBudget - structure.totalYTDActual;
          }
        }

        return structure;
      });

      let total_index = 0;
      for (var i = 0; i < filterStructure.length; i++) {
        if (filterStructure[i].total) {
          if (filterStructure[i].income) {
            profit.incomeActual += filterStructure[i].totalActual;
            profit.incomeBudget += filterStructure[i].totalBudget;
            profit.incomeForecast += filterStructure[i].totalForecast;
            profit.incomeActualVsBudgetVariance +=
              filterStructure[i].totalActual - filterStructure[i].totalBudget;
            profit.incomeActualVsForecastVariance +=
              filterStructure[i].totalActual - filterStructure[i].totalForecast;
            profit.incomeYTDActual += filterStructure[i].totalYTDActual;
            profit.incomeYTDBudget += filterStructure[i].totalYTDBudget;
            profit.incomeYTDForecast += filterStructure[i].totalYTDForecast;
            profit.incomeYTDActualVsBudgetVariance +=
              filterStructure[i].totalYTDActual -
              filterStructure[i].totalYTDBudget;
            profit.incomeYTDActualVsForecastVariance +=
              filterStructure[i].totalYTDActual -
              filterStructure[i].totalYTDForecast;
            if (filterStructure[i].alreadyIncluded) {
              alreadyIncluded.Actual += filterStructure[i].totalActual;
              alreadyIncluded.Budget += filterStructure[i].totalBudget;
              alreadyIncluded.Forecast += filterStructure[i].totalForecast;
              alreadyIncluded.ActualVsBudgetVariance +=
                filterStructure[i].Actual - filterStructure[i].Budget;
              alreadyIncluded.ActualVsForecastVariance +=
                filterStructure[i].Actual - filterStructure[i].Forecast;
              alreadyIncluded.YTDActual += filterStructure[i].totalYTDActual;
              alreadyIncluded.YTDBudget += filterStructure[i].totalYTDBudget;
              alreadyIncluded.YTDForecast +=
                filterStructure[i].totalYTDForecast;
              alreadyIncluded.YTDActualVsBudgetVariance +=
                filterStructure[i].totalYTDActual -
                filterStructure[i].totalYTDBudget;
              alreadyIncluded.YTDActualVsForecastVariance +=
                filterStructure[i].totalYTDActual -
                filterStructure[i].totalYTDForecast;
            }
          } else {
            profit.expenseActual += filterStructure[i].totalActual;
            profit.expenseBudget += filterStructure[i].totalBudget;
            profit.expenseForecast += filterStructure[i].totalForecast;
            profit.expenseActualVsBudgetVariance +=
              filterStructure[i].totalActual - filterStructure[i].totalBudget;
            profit.expenseActualVsForecastVariance +=
              filterStructure[i].totalActual - filterStructure[i].totalForecast;
            profit.expenseYTDActual += filterStructure[i].totalYTDActual;
            profit.expenseYTDBudget += filterStructure[i].totalYTDBudget;
            profit.expenseYTDForecast += filterStructure[i].totalYTDForecast;
            profit.expenseYTDActualVsBudgetVariance +=
              filterStructure[i].totalYTDActual -
              filterStructure[i].totalYTDBudget;
            profit.expenseYTDActualVsForecastVariance +=
              filterStructure[i].totalYTDActual -
              filterStructure[i].totalYTDForecast;
          }
        } else {
          filterStructure[i].profit = {
            incomeActual: 0,
            incomeBudget: 0,
            incomeForecast: 0,
            incomeActualVsBudgetVariance: 0,
            incomeActualVsForecastVariance: 0,
            incomeYTDActual: 0,
            incomeYTDBudget: 0,
            incomeYTDForecast: 0,
            incomeYTDActualVsBudgetVariance: 0,
            incomeYTDActualVsForecastVariance: 0,
            expenseActual: 0,
            expenseBudget: 0,
            expenseForecast: 0,
            expenseActualVsBudgetVariance: 0,
            expenseActualVsForecastVariance: 0,
            expenseYTDActual: 0,
            expenseYTDBudget: 0,
            expenseYTDForecast: 0,
            expenseYTDActualVsBudgetVariance: 0,
            expenseYTDActualVsForecastVariance: 0,
          };
          filterStructure[i].pprofit = {
            Actual: 0,
            ActualVsBudgetVariance: 0,
            ActualVsForecastVariance: 0,
            Budget: 0,
            Forecast: 0,
            YTDActual: 0,
            YTDActualVsBudgetVariance: 0,
            YTDActualVsForecastVariance: 0,
            YTDBudget: 0,
            YTDForecast: 0,
          };
          for (var j = total_index; j < i; j++) {
            if (filterStructure[j].income) {
              filterStructure[i].profit.incomeActual +=
                filterStructure[j].totalActual;
              filterStructure[i].profit.incomeBudget +=
                filterStructure[j].totalBudget;
              filterStructure[i].profit.incomeForecast +=
                filterStructure[j].totalForecast;
              filterStructure[i].profit.incomeActualVsBudgetVariance +=
                filterStructure[j].totalActual - filterStructure[j].totalBudget;
              filterStructure[i].profit.incomeActualVsForecastVariance +=
                filterStructure[j].totalActual -
                filterStructure[j].totalForecast;
              filterStructure[i].profit.incomeYTDActual +=
                filterStructure[j].totalYTDActual;
              filterStructure[i].profit.incomeYTDBudget +=
                filterStructure[j].totalYTDBudget;
              filterStructure[i].profit.incomeYTDForecast +=
                filterStructure[j].totalYTDForecast;
              filterStructure[i].profit.incomeYTDActualVsBudgetVariance +=
                filterStructure[j].totalYTDActual -
                filterStructure[j].totalYTDBudget;
              filterStructure[i].profit.incomeYTDActualVsForecastVariance +=
                filterStructure[j].totalYTDActual -
                filterStructure[j].totalYTDForecast;
            } else {
              filterStructure[i].profit.expenseActual +=
                filterStructure[j].totalActual;
              filterStructure[i].profit.expenseBudget +=
                filterStructure[j].totalBudget;
              filterStructure[i].profit.expenseForecast +=
                filterStructure[j].totalForecast;
              filterStructure[i].profit.expenseActualVsBudgetVariance +=
                filterStructure[j].totalActual - filterStructure[j].totalBudget;
              filterStructure[i].profit.expenseActualVsForecastVariance +=
                filterStructure[j].totalActual -
                filterStructure[j].totalForecast;
              filterStructure[i].profit.expenseYTDActual +=
                filterStructure[j].totalYTDActual;
              filterStructure[i].profit.expenseYTDBudget +=
                filterStructure[j].totalYTDBudget;
              filterStructure[i].profit.expenseYTDForecast +=
                filterStructure[j].totalYTDForecast;
              filterStructure[i].profit.expenseYTDActualVsBudgetVariance +=
                filterStructure[j].totalYTDActual -
                filterStructure[j].totalYTDBudget;
              filterStructure[i].profit.expenseYTDActualVsForecastVariance +=
                filterStructure[j].totalYTDActual -
                filterStructure[j].totalYTDForecast;
            }
          }
          filterStructure[i].pprofit.Actual =
            filterStructure[i].profit.incomeActual !== 0
              ? Math.round(
                  ((filterStructure[i].profit.incomeActual -
                    filterStructure[i].profit.expenseActual) /
                    (filterStructure[i].profit.incomeActual -
                      alreadyIncluded.Actual)) *
                    100,
                )
              : 0;
          filterStructure[i].pprofit.Budget =
            filterStructure[i].profit.incomeBudget !== 0
              ? Math.round(
                  ((filterStructure[i].profit.incomeBudget -
                    filterStructure[i].profit.expenseBudget) /
                    (filterStructure[i].profit.incomeBudget -
                      alreadyIncluded.Budget)) *
                    100,
                )
              : 0;
          filterStructure[i].pprofit.Forecast =
            filterStructure[i].profit.incomeForecast !== 0
              ? Math.round(
                  ((filterStructure[i].profit.incomeForecast -
                    filterStructure[i].profit.expenseForecast) /
                    (filterStructure[i].profit.incomeForecast -
                      alreadyIncluded.Forecast)) *
                    100,
                )
              : 0;
          filterStructure[i].pprofit.ActualVsBudgetVariance =
            filterStructure[i].pprofit.Actual -
            filterStructure[i].pprofit.Budget;
          filterStructure[i].pprofit.ActualVsForecastVariance =
            filterStructure[i].pprofit.Actual -
            filterStructure[i].pprofit.Forecast;
          filterStructure[i].pprofit.YTDActual =
            filterStructure[i].profit.incomeYTDActual !== 0
              ? Math.round(
                  ((filterStructure[i].profit.incomeYTDActual -
                    filterStructure[i].profit.expenseYTDActual) /
                    (filterStructure[i].profit.incomeYTDActual -
                      alreadyIncluded.YTDActual)) *
                    100,
                )
              : 0;
          filterStructure[i].pprofit.YTDBudget =
            filterStructure[i].profit.incomeYTDBudget !== 0
              ? Math.round(
                  ((filterStructure[i].profit.incomeYTDBudget -
                    filterStructure[i].profit.expenseYTDBudget) /
                    (filterStructure[i].profit.incomeYTDBudget -
                      alreadyIncluded.YTDBudget)) *
                    100,
                )
              : 0;
          filterStructure[i].pprofit.YTDForecast =
            filterStructure[i].profit.incomeYTDForecast !== 0
              ? Math.round(
                  ((filterStructure[i].profit.incomeYTDForecast -
                    filterStructure[i].profit.expenseYTDForecast) /
                    (filterStructure[i].profit.incomeYTDForecast -
                      alreadyIncluded.YTDForecast)) *
                    100,
                )
              : 0;
          filterStructure[i].pprofit.YTDActualVsForecastVariance =
            filterStructure[i].pprofit.YTDActual -
            filterStructure[i].pprofit.YTDForecast;
          filterStructure[i].pprofit.YTDActualVsBudgetVariance =
            filterStructure[i].pprofit.YTDActual -
            filterStructure[i].pprofit.YTDBudget;

          total_index = i + 1;
        }
      }

      filterStructure.map((structure) => {
        if (structure.total) {
          structure.totalActualPercent =
            profit.incomeActual === 0
              ? 0
              : Math.round((structure.totalActual / profit.incomeActual) * 100);
          structure.totalBudgetPercent =
            profit.incomeBudget === 0
              ? 0
              : Math.round((structure.totalBudget / profit.incomeBudget) * 100);
          structure.totalForecastPercent =
            profit.incomeForecast === 0
              ? 0
              : Math.round(
                  (structure.totalForecast / profit.incomeForecast) * 100,
                );
          structure.totalYTDActualPercent =
            profit.incomeYTDActual === 0
              ? 0
              : Math.round(
                  (structure.totalYTDActual / profit.incomeYTDActual) * 100,
                );
          structure.totalYTDBudgetPercent =
            profit.incomeYTDBudget === 0
              ? 0
              : Math.round(
                  (structure.totalYTDBudget / profit.incomeYTDBudget) * 100,
                );
          structure.totalYTDForecastPercent =
            profit.incomeYTDForecast === 0
              ? 0
              : Math.round(
                  (structure.totalYTDForecast / profit.incomeYTDForecast) * 100,
                );
          structure.totalActualPercent =
            structure.totalActualPercent >= 0
              ? `${structure.totalActualPercent}%`
              : `(${Math.abs(structure.totalActualPercent)}%)`;
          structure.totalBudgetPercent =
            structure.totalBudgetPercent >= 0
              ? `${structure.totalBudgetPercent}%`
              : `(${Math.abs(structure.totalBudgetPercent)}%)`;
          structure.totalForecastPercent =
            structure.totalForecastPercent >= 0
              ? `${structure.totalForecastPercent}%`
              : `(${Math.abs(structure.totalForecastPercent)}%)`;
          structure.totalYTDActualPercent =
            structure.totalYTDActualPercent >= 0
              ? `${structure.totalYTDActualPercent}%`
              : `(${Math.abs(structure.totalYTDActualPercent)}%)`;
          structure.totalYTDBudgetPercent =
            structure.totalYTDBudgetPercent >= 0
              ? `${structure.totalYTDBudgetPercent}%`
              : `(${Math.abs(structure.totalYTDBudgetPercent)}%)`;
          structure.totalYTDForecastPercent =
            structure.totalYTDForecastPercent >= 0
              ? `${structure.totalYTDForecastPercent}%`
              : `(${Math.abs(structure.totalYTDForecastPercent)}%)`;
        }

        return structure;
      });

      pprofit.Actual =
        profit.incomeActual !== 0
          ? Math.round(
              ((profit.incomeActual - profit.expenseActual) /
                (profit.incomeActual - alreadyIncluded.Actual)) *
                100,
            )
          : 0;
      pprofit.Budget =
        profit.incomeBudget !== 0
          ? Math.round(
              ((profit.incomeBudget - profit.expenseBudget) /
                (profit.incomeBudget - alreadyIncluded.Budget)) *
                100,
            )
          : 0;
      pprofit.Forecast =
        profit.incomeForecast !== 0
          ? Math.round(
              ((profit.incomeForecast - profit.expenseForecast) /
                (profit.incomeForecast - alreadyIncluded.Forecast)) *
                100,
            )
          : 0;
      pprofit.ActualVsBudgetVariance = pprofit.Actual - pprofit.Budget;
      pprofit.ActualVsForecastVariance = pprofit.Actual - pprofit.Forecast;
      pprofit.YTDActual =
        profit.incomeYTDActual !== 0
          ? Math.round(
              ((profit.incomeYTDActual - profit.expenseYTDActual) /
                (profit.incomeYTDActual - alreadyIncluded.YTDActual)) *
                100,
            )
          : 0;
      pprofit.YTDBudget =
        profit.incomeYTDBudget !== 0
          ? Math.round(
              ((profit.incomeYTDBudget - profit.expenseYTDBudget) /
                (profit.incomeYTDBudget - alreadyIncluded.YTDBudget)) *
                100,
            )
          : 0;
      pprofit.YTDForecast =
        profit.incomeYTDForecast !== 0
          ? Math.round(
              ((profit.incomeYTDForecast - profit.expenseYTDForecast) /
                (profit.incomeYTDForecast - alreadyIncluded.YTDForecast)) *
                100,
            )
          : 0;
      pprofit.YTDActualVsBudgetVariance = pprofit.YTDActual - pprofit.YTDBudget;
      pprofit.YTDActualVsForecastVariance =
        pprofit.YTDActual - pprofit.YTDForecast;

      setTableStructure(filterStructure);
      setProfit(profit);
      setPProfit(pprofit);
    }
    deSelectAll();
  }, [detailData]);

  useEffect(() => {
    prepareData();
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, [prepareData, onResize]);

  useEffect(() => {
    setProfitName(initialProfitName);
  }, [initialProfitName]);

  useEffect(() => {
    setPProfitName(initialPProfitName);
  }, [initialPProfitName]);

  // Event handlers
  const handleChangeShowPercent = (event) => {
    handleFilter({ showPercent: event.target.checked });
  };

  const handleChange = (event) => {
    handleFilter({ selectedOption: event.target.value });
  };

  const handleElement = (event, element) => {
    let _selectedIdRects = [];
    let exist = false,
      index = NaN;
    switch (element) {
      case 'table':
        if (event.shiftKey) {
          _selectedIdRects = selectedIdRects.slice();
          for (let i = 0; i < selectedIdRects.length; i++) {
            if (selectedIdRects[i] === event.target) {
              index = i;
              break;
            }
          }
          if (isNaN(index)) {
            event.target.classList.add('bkgActive');
            _selectedIdRects.push(event.target);
          } else {
            event.target.classList.remove('bkgActive');
            _selectedIdRects.splice(index, 1);
          }
        } else {
          selectedIdRects.forEach((rect) => {
            rect.classList.remove('bkgActive');
            if (rect === event.target) exist = true;
          });
          if (exist && selectedIdRects.length === 1) {
            _selectedIdRects = [];
          } else {
            event.target.classList.add('bkgActive');
            _selectedIdRects = [event.target];
          }
        }
        break;
      default:
        break;
    }
    setSelectedIdRects(_selectedIdRects);
  };

  const deSelectAll = () => {
    selectedIdRects.forEach((rect) => {
      rect.classList.remove('bkgActive');
    });
    setSelectedIdRects([]);
  };

  const handlePos = (event) => {
    const _pos = event.currentTarget.getBoundingClientRect().top + window.scrollY;
    if (pageOffset !== _pos) {
      setPageOffset(_pos);
    }
  };

  const handleChangeProfitName = (event, type) => {
    if (type === 'profit') setProfitName(event.target.value);
    else setPProfitName(event.target.value);
  };

  const handleSubmitProfitName = (type) => {
    if (type === 'profit') handleFilter({ profitName });
    else handleFilter({ pprofitName });
  };

  return (
    <div
      id="fpy_area"
      style={{ marginTop: 20 }}
      onMouseMove={handlePos}
      onTouchMove={handlePos}
    >
      <div style={{ paddingBottom: 10 }}>
        <FormControlLabel
          control={
            <FormControl variant="standard">
              <Select
                onChange={handleChange}
                sx={{
                  '& .MuiInputBase-input': {
                    padding: 0,
                    paddingRight: 24,
                    fontWeight: 'bold',
                    fontFamily: 'Verdana !important',
                    fontSize: '10pt',
                  },
                }}
                value={selectedOption}
              >
                <MenuItem value="Forecast">Forecast</MenuItem>
                <MenuItem value="Budget">Budget</MenuItem>
              </Select>
            </FormControl>
          }
          label="Profit / Loss vs&nbsp;"
          labelPlacement="start"
          sx={{
            marginLeft: '0px !important',
            '& .MuiTypography-root': {
              fontWeight: 'bold',
              fontFamily: 'Verdana !important',
              fontSize: '10pt',
            },
          }}
        />
        <FormControlLabel
          id="fpy_percent"
          control={
            <Checkbox
              checked={showPercent}
              onChange={handleChangeShowPercent}
              color="success"
            />
          }
          label="Show %"
          labelPlacement="start"
          sx={{
            '& .MuiFormControlLabel-label': {
              fontWeight: 'bold',
              fontFamily: 'Verdana !important',
              fontSize: '10pt',
            },
            '& .MuiCheckbox-colorPrimary': {
              color: '#1976d2',
            },
          }}
        />
      </div>

      {tableStructure.length > 0 ? (
        <div
          id="fpy_bottom"
          className="well"
          style={{
            overflow: 'auto',
            maxHeight: '506px',
            overflowX: 'hidden',
          }}
        >
          <Grid container style={{ fontSize: 12 }}>
            <Grid
              size={{ xs: 3 }}
              style={{ borderBottom: '1px solid lightgrey', height: 20 }}
            ></Grid>
            <Grid
              container
              size={{ xs: 9 }}
              style={{
                textAlign: 'center',
                borderBottom: '1px solid lightgrey',
                height: 20,
              }}
            >
              <div
                style={{
                  float: 'left',
                  width: showPercent ? 'calc(16.67% - 65px)' : '16.67%',
                }}
              >
                <b>MTD Actual</b>
              </div>
              {showPercent ? (
                <div
                  style={{
                    float: 'left',
                    width: 65,
                  }}
                >
                  <b>%</b>
                </div>
              ) : null}
              <div
                style={{
                  float: 'left',
                  width: showPercent ? 'calc(16.67% - 65px)' : '16.67%',
                }}
              >
                <b>
                  {selectedOption === 'Forecast'
                    ? 'MTD Forecast'
                    : 'MTD Budget'}
                </b>
              </div>
              {showPercent ? (
                <div
                  style={{
                    float: 'left',
                    width: 65,
                  }}
                >
                  <b>%</b>
                </div>
              ) : null}
              <div
                style={{
                  float: 'left',
                  width: '16.67%',
                }}
              >
                <b>MTD Variance</b>
              </div>
              <div
                style={{
                  float: 'left',
                  width: showPercent ? 'calc(16.67% - 65px)' : '16.67%',
                }}
              >
                <b>YTD Actual</b>
              </div>
              {showPercent ? (
                <div
                  style={{
                    float: 'left',
                    width: 65,
                  }}
                >
                  <b>%</b>
                </div>
              ) : null}
              <div
                style={{
                  float: 'left',
                  width: showPercent ? 'calc(16.67% - 65px)' : '16.67%',
                }}
              >
                <b>
                  {selectedOption === 'Forecast'
                    ? 'YTD Forecast'
                    : 'YTD Budget'}
                </b>
              </div>
              {showPercent ? (
                <div
                  style={{
                    float: 'left',
                    width: 65,
                  }}
                >
                  <b>%</b>
                </div>
              ) : null}
              <div
                style={{
                  float: 'left',
                  width: '16.65%',
                }}
              >
                <b>YTD Variance</b>
              </div>
            </Grid>
            {tableStructure.map((parent, pIndex) => {
              if (parent.total) {
                return (
                  <React.Fragment key={pIndex}>
                    <Grid size={{ xs: 3 }}>
                      <div>
                        {parent.total &&
                          parent.subItems.map((child, cIndex) => (
                            <Grid container key={cIndex}>
                              {cIndex === 0 ? (
                                <Grid
                                  size={{ xs: 4 }}
                                  style={{
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    display: 'flex',
                                    alignItems: 'center',
                                  }}
                                >
                                  <b>{parent.content}</b>
                                </Grid>
                              ) : (
                                <Grid size={{ xs: 4 }}></Grid>
                              )}
                              <Grid
                                size={{ xs: 8 }}
                                style={{
                                  ...tableBorder,
                                  backgroundColor:
                                    parent.subItems.length % 2 === 0
                                      ? cIndex % 2 === 0
                                        ? '#f7f7f7'
                                        : '#ffffff'
                                      : cIndex % 2 === 0
                                      ? '#ffffff'
                                      : '#f7f7f7',
                                  justifyContent: 'start',
                                }}
                              >
                                {child.content}
                              </Grid>
                            </Grid>
                          ))}
                        <Grid container>
                          <Grid size={{ xs: 4 }}></Grid>
                          <Grid
                            size={{ xs: 8 }}
                            style={{
                              ...tableBorder,
                              backgroundColor: '#f7f7f7',
                              justifyContent: 'start',
                            }}
                          >
                            <b>{parent.totalTitle}</b>
                          </Grid>
                        </Grid>
                      </div>
                    </Grid>

                    <Grid
                      size={{ xs: 9 }}
                      style={{
                        textAlign: 'center',
                      }}
                    >
                      <div>
                        {parent.total &&
                          parent.subItems.map((child, cIndex) => (
                            <Grid container key={cIndex}>
                              <div
                                style={{
                                  ...tableBorder,
                                  float: 'left',
                                  width: showPercent
                                    ? 'calc(16.67% - 65px)'
                                    : '16.67%',
                                  backgroundColor:
                                    parent.subItems.length % 2 === 0
                                      ? cIndex % 2 === 0
                                        ? '#f7f7f7'
                                        : '#ffffff'
                                      : cIndex % 2 === 0
                                      ? '#ffffff'
                                      : '#f7f7f7',
                                }}
                                onClick={(event) => {
                                  handleElement(event, 'table');
                                }}
                              >
                                {child.Actual >= 0
                                  ? thousandFormat2(child.Actual)
                                  : `(${thousandFormat2(
                                      Math.abs(child.Actual),
                                    )})`}
                              </div>
                              {showPercent ? (
                                <div
                                  style={{
                                    ...tableBorder,
                                    float: 'left',
                                    width: 65,
                                    backgroundColor:
                                      parent.subItems.length % 2 === 0
                                        ? cIndex % 2 === 0
                                          ? '#f7f7f7'
                                          : '#ffffff'
                                        : cIndex % 2 === 0
                                        ? '#ffffff'
                                        : '#f7f7f7',
                                  }}
                                >
                                  {profit.incomeActual === 0
                                    ? '0%'
                                    : Math.round(
                                        (child.Actual / profit.incomeActual) *
                                          100,
                                      ) >= 0
                                    ? `${Math.round(
                                        (child.Actual / profit.incomeActual) *
                                          100,
                                      )}%`
                                    : `(${Math.round(
                                        Math.abs(
                                          (child.Actual /
                                            profit.incomeActual) *
                                            100,
                                        ),
                                      )}%)`}
                                </div>
                              ) : null}
                              <div
                                style={{
                                  ...tableBorder,
                                  float: 'left',
                                  width: showPercent
                                    ? 'calc(16.67% - 65px)'
                                    : '16.67%',
                                  backgroundColor:
                                    parent.subItems.length % 2 === 0
                                      ? cIndex % 2 === 0
                                        ? '#f7f7f7'
                                        : '#ffffff'
                                      : cIndex % 2 === 0
                                      ? '#ffffff'
                                      : '#f7f7f7',
                                }}
                                onClick={(event) => {
                                  handleElement(event, 'table');
                                }}
                              >
                                {selectedOption === 'Forecast'
                                  ? child.Forecast >= 0
                                    ? thousandFormat2(child.Forecast)
                                    : `(${thousandFormat2(
                                        Math.abs(child.Forecast),
                                      )})`
                                  : child.Budget >= 0
                                  ? thousandFormat2(child.Budget)
                                  : `(${thousandFormat2(
                                      Math.abs(child.Budget),
                                    )})`}
                              </div>
                              {showPercent ? (
                                <div
                                  style={{
                                    ...tableBorder,
                                    float: 'left',
                                    width: 65,
                                    backgroundColor:
                                      parent.subItems.length % 2 === 0
                                        ? cIndex % 2 === 0
                                          ? '#f7f7f7'
                                          : '#ffffff'
                                        : cIndex % 2 === 0
                                        ? '#ffffff'
                                        : '#f7f7f7',
                                  }}
                                >
                                  {selectedOption === 'Forecast'
                                    ? profit.incomeForecast === 0
                                      ? '0%'
                                      : Math.round(
                                          (child.Forecast /
                                            profit.incomeForecast) *
                                            100,
                                        ) >= 0
                                      ? `${Math.round(
                                          (child.Forecast /
                                            profit.incomeForecast) *
                                            100,
                                          )}%`
                                      : `(${Math.round(
                                          Math.abs(
                                            (child.Forecast /
                                              profit.incomeForecast) *
                                              100,
                                          ),
                                        )}%)`
                                    : profit.incomeBudget === 0
                                    ? '0%'
                                    : Math.round(
                                        (child.Budget / profit.incomeBudget) *
                                          100,
                                      ) >= 0
                                    ? `${Math.round(
                                        (child.Budget / profit.incomeBudget) *
                                          100,
                                      )}%`
                                    : `(${Math.round(
                                        Math.abs(
                                          (child.Budget /
                                            profit.incomeBudget) *
                                            100,
                                        ),
                                      )}%)`}
                                </div>
                              ) : null}
                              <div
                                style={{
                                  ...tableBorder,
                                  float: 'left',
                                  width: '16.67%',
                                  backgroundColor:
                                    parent.subItems.length % 2 === 0
                                      ? cIndex % 2 === 0
                                        ? '#f7f7f7'
                                        : '#ffffff'
                                      : cIndex % 2 === 0
                                      ? '#ffffff'
                                      : '#f7f7f7',
                                  color:
                                    selectedOption === 'Forecast'
                                      ? child.ActualVsForecastVariance > 0
                                        ? '#389a38'
                                        : 'black'
                                      : child.ActualVsBudgetVariance > 0
                                      ? '#389a38'
                                      : 'black',
                                }}
                                onClick={(event) => {
                                  handleElement(event, 'table');
                                }}
                              >
                                {selectedOption === 'Forecast'
                                  ? child.ActualVsForecastVariance >= 0
                                    ? thousandFormat2(
                                        child.ActualVsForecastVariance,
                                      )
                                    : `(${thousandFormat2(
                                        Math.abs(
                                          child.ActualVsForecastVariance,
                                        ),
                                      )})`
                                  : child.ActualVsBudgetVariance >= 0
                                  ? thousandFormat2(
                                      child.ActualVsBudgetVariance,
                                    )
                                  : `(${thousandFormat2(
                                      Math.abs(child.ActualVsBudgetVariance),
                                    )})`}
                              </div>
                              <div
                                style={{
                                  ...tableBorder,
                                  float: 'left',
                                  width: showPercent
                                    ? 'calc(16.67% - 65px)'
                                    : '16.67%',
                                  backgroundColor:
                                    parent.subItems.length % 2 === 0
                                      ? cIndex % 2 === 0
                                        ? '#f7f7f7'
                                        : '#f0f0f0'
                                      : cIndex % 2 === 0
                                      ? '#f0f0f0'
                                      : '#f7f7f7',
                                }}
                                onClick={(event) => {
                                  handleElement(event, 'table');
                                }}
                              >
                                {child.YTDActual >= 0
                                  ? thousandFormat2(child.YTDActual)
                                  : `(${thousandFormat2(
                                      Math.abs(child.YTDActual),
                                    )})`}
                              </div>
                              {showPercent ? (
                                <div
                                  style={{
                                    ...tableBorder,
                                    float: 'left',
                                    width: 65,
                                    backgroundColor:
                                      parent.subItems.length % 2 === 0
                                        ? cIndex % 2 === 0
                                          ? '#f7f7f7'
                                          : '#f0f0f0'
                                        : cIndex % 2 === 0
                                        ? '#f0f0f0'
                                        : '#f7f7f7',
                                  }}
                                >
                                  {profit.incomeYTDActual === 0
                                    ? '0%'
                                    : Math.round(
                                        (child.YTDActual /
                                          profit.incomeYTDActual) *
                                          100,
                                      ) >= 0
                                    ? `${Math.round(
                                        (child.YTDActual /
                                          profit.incomeYTDActual) *
                                          100,
                                      )}%`
                                    : `(${Math.round(
                                        Math.abs(
                                          (child.YTDActual /
                                            profit.incomeYTDActual) *
                                            100,
                                        ),
                                      )}%)`}
                                </div>
                              ) : null}
                              <div
                                style={{
                                  ...tableBorder,
                                  float: 'left',
                                  width: showPercent
                                    ? 'calc(16.67% - 65px)'
                                    : '16.67%',
                                  backgroundColor:
                                    parent.subItems.length % 2 === 0
                                      ? cIndex % 2 === 0
                                        ? '#f7f7f7'
                                        : '#f0f0f0'
                                      : cIndex % 2 === 0
                                      ? '#f0f0f0'
                                      : '#f7f7f7',
                                }}
                                onClick={(event) => {
                                  handleElement(event, 'table');
                                }}
                              >
                                {selectedOption === 'Forecast'
                                  ? child.YTDForecast >= 0
                                    ? thousandFormat2(child.YTDForecast)
                                    : `(${thousandFormat2(
                                        Math.abs(child.YTDForecast),
                                      )})`
                                  : child.YTDBudget >= 0
                                  ? thousandFormat2(child.YTDBudget)
                                  : `(${thousandFormat2(
                                      Math.abs(child.YTDBudget),
                                    )})`}
                              </div>
                              {showPercent ? (
                                <div
                                  style={{
                                    ...tableBorder,
                                    float: 'left',
                                    width: 65,
                                    backgroundColor:
                                      parent.subItems.length % 2 === 0
                                        ? cIndex % 2 === 0
                                          ? '#f7f7f7'
                                          : '#f0f0f0'
                                        : cIndex % 2 === 0
                                        ? '#f0f0f0'
                                        : '#f7f7f7',
                                  }}
                                >
                                  {selectedOption === 'Forecast'
                                    ? profit.incomeYTDForecast === 0
                                      ? '0%'
                                      : Math.round(
                                          (child.YTDForecast /
                                            profit.incomeYTDForecast) *
                                            100,
                                        ) >= 0
                                      ? `${Math.round(
                                          (child.YTDForecast /
                                            profit.incomeYTDForecast) *
                                            100,
                                          )}%`
                                      : `(${Math.round(
                                          Math.abs(
                                            (child.YTDForecast /
                                              profit.incomeYTDForecast) *
                                              100,
                                          ),
                                        )}%)`
                                    : profit.incomeYTDBudget === 0
                                    ? '0%'
                                    : Math.round(
                                        (child.YTDBudget /
                                          profit.incomeYTDBudget) *
                                          100,
                                      ) >= 0
                                    ? `${Math.round(
                                        (child.YTDBudget /
                                          profit.incomeYTDBudget) *
                                          100,
                                      )}%`
                                    : `(${Math.round(
                                        Math.abs(
                                          (child.YTDBudget /
                                            profit.incomeYTDBudget) *
                                            100,
                                        ),
                                      )}%)`}
                                </div>
                              ) : null}
                              <div
                                style={{
                                  ...tableBorder,
                                  float: 'left',
                                  width: '16.65%',
                                  backgroundColor:
                                    parent.subItems.length % 2 === 0
                                      ? cIndex % 2 === 0
                                        ? '#f7f7f7'
                                        : '#f0f0f0'
                                      : cIndex % 2 === 0
                                      ? '#f0f0f0'
                                      : '#f7f7f7',
                                  color:
                                    selectedOption === 'Forecast'
                                      ? child.YTDActualVsForecastVariance > 0
                                        ? '#389a38'
                                        : 'black'
                                      : child.YTDActualVsBudgetVariance > 0
                                      ? '#389a38'
                                      : 'black',
                                }}
                                onClick={(event) => {
                                  handleElement(event, 'table');
                                }}
                              >
                                {selectedOption === 'Forecast'
                                  ? child.YTDActualVsForecastVariance >= 0
                                    ? thousandFormat2(
                                        child.YTDActualVsForecastVariance,
                                      )
                                    : `(${thousandFormat2(
                                        Math.abs(
                                          child.YTDActualVsForecastVariance,
                                        ),
                                      )})`
                                  : child.YTDActualVsBudgetVariance >= 0
                                  ? thousandFormat2(
                                      child.YTDActualVsBudgetVariance,
                                    )
                                  : `(${thousandFormat2(
                                      Math.abs(
                                        child.YTDActualVsBudgetVariance,
                                      ),
                                    )})`}
                              </div>
                            </Grid>
                          ))}

                        <Grid container>
                          <div
                            style={{
                              ...tableBorder,
                              float: 'left',
                              width: showPercent
                                ? 'calc(16.67% - 65px)'
                                : '16.67%',
                              backgroundColor: '#f7f7f7',
                            }}
                            onClick={(event) => {
                              handleElement(event, 'table');
                            }}
                          >
                            <b>
                              {parent.totalActual >= 0
                                ? thousandFormat2(parent.totalActual)
                                : `(${thousandFormat2(
                                    Math.abs(parent.totalActual),
                                  )})`}
                            </b>
                          </div>
                          {showPercent ? (
                            <div
                              style={{
                                ...tableBorder,
                                float: 'left',
                                width: 65,
                                backgroundColor: '#f7f7f7',
                              }}
                            >
                              <b>{parent.totalActualPercent}</b>
                            </div>
                          ) : null}
                          <div
                            style={{
                              ...tableBorder,
                              float: 'left',
                              width: showPercent
                                ? 'calc(16.67% - 65px)'
                                : '16.67%',
                              backgroundColor: '#f7f7f7',
                            }}
                            onClick={(event) => {
                              handleElement(event, 'table');
                            }}
                          >
                            <b>
                              {selectedOption === 'Forecast'
                                ? parent.totalForecast >= 0
                                  ? thousandFormat2(parent.totalForecast)
                                  : `(${thousandFormat2(
                                      Math.abs(parent.totalForecast),
                                    )})`
                                : parent.totalBudget >= 0
                                ? thousandFormat2(parent.totalBudget)
                                : `(${thousandFormat2(
                                    Math.abs(parent.totalBudget),
                                  )})`}
                            </b>
                          </div>
                          {showPercent ? (
                            <div
                              style={{
                                ...tableBorder,
                                float: 'left',
                                width: 65,
                                backgroundColor: '#f7f7f7',
                              }}
                            >
                              <b>
                                {selectedOption === 'Forecast'
                                  ? parent.totalForecastPercent
                                  : parent.totalBudgetPercent}
                              </b>
                            </div>
                          ) : null}
                          <div
                            style={{
                              ...tableBorder,
                              float: 'left',
                              width: '16.67%',
                              backgroundColor: '#f7f7f7',
                              color:
                                selectedOption === 'Forecast'
                                  ? parent.totalActualVsForecastVariance > 0
                                    ? '#389a38'
                                    : 'black'
                                  : parent.totalActualVsBudgetVariance > 0
                                  ? '#389a38'
                                  : 'black',
                            }}
                            onClick={(event) => {
                              handleElement(event, 'table');
                            }}
                          >
                            <b>
                              {selectedOption === 'Forecast'
                                ? parent.totalActualVsForecastVariance >= 0
                                  ? thousandFormat2(
                                      parent.totalActualVsForecastVariance,
                                    )
                                  : `(${thousandFormat2(
                                      Math.abs(
                                        parent.totalActualVsForecastVariance,
                                      ),
                                    )})`
                                : parent.totalActualVsBudgetVariance >= 0
                                ? thousandFormat2(
                                    parent.totalActualVsBudgetVariance,
                                  )
                                : `(${thousandFormat2(
                                    Math.abs(
                                      parent.totalActualVsBudgetVariance,
                                    ),
                                  )})`}
                            </b>
                          </div>
                          <div
                            style={{
                              ...tableBorder,
                              float: 'left',
                              width: showPercent
                                ? 'calc(16.67% - 65px)'
                                : '16.67%',
                              backgroundColor: '#f7f7f7',
                            }}
                            onClick={(event) => {
                              handleElement(event, 'table');
                            }}
                          >
                            <b>
                              {parent.totalYTDActual >= 0
                                ? thousandFormat2(parent.totalYTDActual)
                                : `(${thousandFormat2(
                                    Math.abs(parent.totalYTDActual),
                                  )})`}
                            </b>
                          </div>
                          {showPercent ? (
                            <div
                              style={{
                                ...tableBorder,
                                float: 'left',
                                width: 65,
                                backgroundColor: '#f7f7f7',
                              }}
                            >
                              <b>{parent.totalYTDActualPercent}</b>
                            </div>
                          ) : null}
                          <div
                            style={{
                              ...tableBorder,
                              float: 'left',
                              width: showPercent
                                ? 'calc(16.67% - 65px)'
                                : '16.67%',
                              backgroundColor: '#f7f7f7',
                            }}
                            onClick={(event) => {
                              handleElement(event, 'table');
                            }}
                          >
                            <b>
                              {selectedOption === 'Forecast'
                                ? parent.totalYTDForecast >= 0
                                  ? thousandFormat2(parent.totalYTDForecast)
                                  : `(${thousandFormat2(
                                      Math.abs(parent.totalYTDForecast),
                                    )})`
                                : parent.totalYTDBudget >= 0
                                ? thousandFormat2(parent.totalYTDBudget)
                                : `(${thousandFormat2(
                                    Math.abs(parent.totalYTDBudget),
                                  )})`}
                            </b>
                          </div>
                          {showPercent ? (
                            <div
                              style={{
                                ...tableBorder,
                                float: 'left',
                                width: 65,
                                backgroundColor: '#f7f7f7',
                              }}
                            >
                              <b>
                                {selectedOption === 'Forecast'
                                  ? parent.totalYTDForecastPercent
                                  : parent.totalYTDBudgetPercent}
                              </b>
                            </div>
                          ) : null}
                          <div
                            style={{
                              ...tableBorder,
                              float: 'left',
                              width: '16.65%',
                              backgroundColor: '#f7f7f7',
                              color:
                                selectedOption === 'Forecast'
                                  ? parent.totalYTDActualVsForecastVariance >
                                    0
                                    ? '#389a38'
                                    : 'black'
                                  : parent.totalYTDActualVsBudgetVariance > 0
                                  ? '#389a38'
                                  : 'black',
                            }}
                            onClick={(event) => {
                              handleElement(event, 'table');
                            }}
                          >
                            <b>
                              {selectedOption === 'Forecast'
                                ? parent.totalYTDActualVsForecastVariance >= 0
                                  ? thousandFormat2(
                                      parent.totalYTDActualVsForecastVariance,
                                    )
                                  : `(${thousandFormat2(
                                      Math.abs(
                                        parent.totalYTDActualVsForecastVariance,
                                      ),
                                    )})`
                                : parent.totalYTDActualVsBudgetVariance >= 0
                                ? thousandFormat2(
                                    parent.totalYTDActualVsBudgetVariance,
                                  )
                                : `(${thousandFormat2(
                                    Math.abs(
                                      parent.totalYTDActualVsBudgetVariance,
                                    ),
                                  )})`}
                            </b>
                          </div>
                        </Grid>
                      </div>
                    </Grid>
                  </React.Fragment>
                );
              } else {
                return (
                  <React.Fragment key={pIndex}>
                    <Grid container size={{ xs: 3 }}>
                      <Grid
                        size={{ xs: 4 }}
                        style={{
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        <b>{parent.content}</b>
                      </Grid>
                      <Grid
                        size={{ xs: 8 }}
                        style={{ ...tableBorder, justifyContent: 'start' }}
                      >
                        <b>Profit / Loss</b>
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      size={{ xs: 9 }}
                      style={{ textAlign: 'center' }}
                    >
                      <div
                        style={{
                          ...tableBorder,
                          backgroundColor: '#f7f7f7',
                          float: 'left',
                          width: '16.67%',
                        }}
                        onClick={(event) => {
                          handleElement(event, 'table');
                        }}
                      >
                        <b>
                          {parent.profit.incomeActual -
                            parent.profit.expenseActual >=
                          0
                            ? thousandFormat2(
                                parent.profit.incomeActual -
                                  parent.profit.expenseActual,
                              )
                            : `(${thousandFormat2(
                                Math.abs(
                                  parent.profit.incomeActual -
                                    parent.profit.expenseActual,
                                ),
                              )})`}
                        </b>
                      </div>
                      <div
                        style={{
                          ...tableBorder,
                          backgroundColor: '#f7f7f7',
                          float: 'left',
                          width: '16.67%',
                        }}
                        onClick={(event) => {
                          handleElement(event, 'table');
                        }}
                      >
                        <b>
                          {selectedOption === 'Forecast'
                            ? parent.profit.incomeForecast -
                                parent.profit.expenseForecast >=
                              0
                              ? thousandFormat2(
                                  parent.profit.incomeForecast -
                                    parent.profit.expenseForecast,
                                )
                              : `(${thousandFormat2(
                                  Math.abs(
                                    parent.profit.incomeForecast -
                                      parent.profit.expenseForecast,
                                  ),
                                )})`
                            : parent.profit.incomeBudget -
                                parent.profit.expenseBudget >=
                              0
                            ? thousandFormat2(
                                parent.profit.incomeBudget -
                                  parent.profit.expenseBudget,
                              )
                            : `(${thousandFormat2(
                                Math.abs(
                                  parent.profit.incomeBudget -
                                    parent.profit.expenseBudget,
                                ),
                              )})`}
                        </b>
                      </div>
                      <div
                        style={{
                          ...tableBorder,
                          float: 'left',
                          width: '16.67%',
                          backgroundColor: '#f7f7f7',
                          color:
                            selectedOption === 'Forecast'
                              ? parent.profit.incomeActualVsForecastVariance -
                                  parent.profit
                                    .expenseActualVsForecastVariance >
                                0
                                ? '#389a38'
                                : 'black'
                              : parent.profit.incomeActualVsBudgetVariance -
                                  parent.profit
                                    .expenseActualVsBudgetVariance >
                                0
                              ? '#389a38'
                              : 'black',
                        }}
                        onClick={(event) => {
                          handleElement(event, 'table');
                        }}
                      >
                        <b>
                          {selectedOption === 'Forecast'
                            ? parent.profit.incomeActualVsForecastVariance -
                                parent.profit
                                  .expenseActualVsForecastVariance >=
                                0
                                ? thousandFormat2(
                                    parent.profit
                                      .incomeActualVsForecastVariance -
                                      parent.profit
                                        .expenseActualVsForecastVariance,
                                  )
                                : `(${thousandFormat2(
                                    Math.abs(
                                      parent.profit
                                        .incomeActualVsForecastVariance -
                                        parent.profit
                                          .expenseActualVsForecastVariance,
                                    ),
                                  )})`
                            : parent.profit.incomeActualVsBudgetVariance -
                                parent.profit.expenseActualVsBudgetVariance >=
                              0
                            ? thousandFormat2(
                                parent.profit.incomeActualVsBudgetVariance -
                                  parent.profit.expenseActualVsBudgetVariance,
                              )
                            : `(${thousandFormat2(
                                Math.abs(
                                  parent.profit.incomeActualVsBudgetVariance -
                                    parent.profit
                                      .expenseActualVsBudgetVariance,
                                ),
                              )})`}
                        </b>
                      </div>
                      <div
                        style={{
                          ...tableBorder,
                          backgroundColor: '#f7f7f7',
                          float: 'left',
                          width: '16.67%',
                        }}
                        onClick={(event) => {
                          handleElement(event, 'table');
                        }}
                      >
                        <b>
                          {parent.profit.incomeYTDActual -
                            parent.profit.expenseYTDActual >=
                          0
                            ? thousandFormat2(
                                parent.profit.incomeYTDActual -
                                  parent.profit.expenseYTDActual,
                              )
                            : `(${thousandFormat2(
                                Math.abs(
                                  parent.profit.incomeYTDActual -
                                    parent.profit.expenseYTDActual,
                                ),
                              )})`}
                        </b>
                      </div>
                      <div
                        style={{
                          ...tableBorder,
                          backgroundColor: '#f7f7f7',
                          float: 'left',
                          width: '16.67%',
                        }}
                        onClick={(event) => {
                          handleElement(event, 'table');
                        }}
                      >
                        <b>
                          {selectedOption === 'Forecast'
                            ? parent.profit.incomeYTDForecast -
                                parent.profit.expenseYTDForecast >=
                              0
                              ? thousandFormat2(
                                  parent.profit.incomeYTDForecast -
                                    parent.profit.expenseYTDForecast,
                                )
                              : `(${thousandFormat2(
                                  Math.abs(
                                    parent.profit.incomeYTDForecast -
                                      parent.profit.expenseYTDForecast,
                                  ),
                                )})`
                            : parent.profit.incomeYTDBudget -
                                parent.profit.expenseYTDBudget >=
                              0
                            ? thousandFormat2(
                                parent.profit.incomeYTDBudget -
                                  parent.profit.expenseYTDBudget,
                              )
                            : `(${thousandFormat2(
                                Math.abs(
                                  parent.profit.incomeYTDBudget -
                                    parent.profit.expenseYTDBudget,
                                ),
                              )})`}
                        </b>
                      </div>
                      <div
                        style={{
                          ...tableBorder,
                          float: 'left',
                          width: '16.65%',
                          backgroundColor: '#f7f7f7',
                          color:
                            selectedOption === 'Forecast'
                              ? parent.profit
                                  .incomeYTDActualVsForecastVariance -
                                  parent.profit
                                    .expenseYTDActualVsForecastVariance >
                                0
                                ? '#389a38'
                                : 'black'
                              : parent.profit
                                  .incomeYTDActualVsBudgetVariance -
                                  parent.profit
                                    .expenseYTDActualVsBudgetVariance >
                                0
                              ? '#389a38'
                              : 'black',
                        }}
                        onClick={(event) => {
                          handleElement(event, 'table');
                        }}
                      >
                        <b>
                          {selectedOption === 'Forecast'
                            ? parent.profit
                                .incomeYTDActualVsForecastVariance -
                                parent.profit
                                  .expenseYTDActualVsForecastVariance >=
                                0
                                ? thousandFormat2(
                                    parent.profit
                                      .incomeYTDActualVsForecastVariance -
                                      parent.profit
                                        .expenseYTDActualVsForecastVariance,
                                  )
                                : `(${thousandFormat2(
                                    Math.abs(
                                      parent.profit
                                        .incomeYTDActualVsForecastVariance -
                                        parent.profit
                                          .expenseYTDActualVsForecastVariance,
                                    ),
                                  )})`
                            : parent.profit.incomeYTDActualVsBudgetVariance -
                                parent.profit
                                  .expenseYTDActualVsBudgetVariance >=
                                0
                              ? thousandFormat2(
                                  parent.profit
                                    .incomeYTDActualVsBudgetVariance -
                                    parent.profit
                                      .expenseYTDActualVsBudgetVariance,
                                )
                              : `(${thousandFormat2(
                                  Math.abs(
                                    parent.profit
                                      .incomeYTDActualVsBudgetVariance -
                                      parent.profit
                                        .expenseYTDActualVsBudgetVariance,
                                  ),
                                )})`}
                        </b>
                      </div>
                    </Grid>

                    {/* Total %profit */}

                    <Grid container size={{ xs: 3 }}>
                      <Grid
                        size={{ xs: 4 }}
                        style={{
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        <b>% {parent.content}</b>
                      </Grid>
                      <Grid
                        size={{ xs: 8 }}
                        style={{
                          ...tableBorder,
                          justifyContent: 'start',
                          backgroundColor: '#f7f7f7',
                        }}
                      >
                        <b>% Profit / Loss</b>
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      size={{ xs: 9 }}
                      style={{ textAlign: 'center' }}
                    >
                      <div
                        style={{
                          ...tableBorder,
                          backgroundColor: '#f7f7f7',
                          float: 'left',
                          width: '16.67%',
                        }}
                        onClick={(event) => {
                          handleElement(event, 'table');
                        }}
                      >
                        <b>
                          {parent.pprofit.Actual >= 0
                            ? `${parent.pprofit.Actual}%`
                            : `(${Math.abs(parent.pprofit.Actual)}%)`}
                        </b>
                      </div>
                      <div
                        style={{
                          ...tableBorder,
                          backgroundColor: '#f7f7f7',
                          float: 'left',
                          width: '16.67%',
                        }}
                        onClick={(event) => {
                          handleElement(event, 'table');
                        }}
                      >
                        <b>
                          {selectedOption === 'Forecast'
                            ? parent.pprofit.Forecast >= 0
                              ? `${parent.pprofit.Forecast}%`
                              : `(${Math.abs(parent.pprofit.Forecast)}%)`
                            : parent.pprofit.Budget >= 0
                            ? `${parent.pprofit.Budget}%`
                            : `(${Math.abs(parent.pprofit.Budget)}%)`}
                        </b>
                      </div>
                      <div
                        style={{
                          ...tableBorder,
                          float: 'left',
                          width: '16.67%',
                          backgroundColor: '#f7f7f7',
                          color:
                            selectedOption === 'Forecast'
                              ? parent.pprofit.ActualVsForecastVariance > 0
                                ? '#389a38'
                                : 'black'
                              : parent.pprofit.ActualVsBudgetVariance > 0
                              ? '#389a38'
                              : 'black',
                        }}
                        onClick={(event) => {
                          handleElement(event, 'table');
                        }}
                      >
                        <b>
                          {selectedOption === 'Forecast'
                            ? parent.pprofit.ActualVsForecastVariance >= 0
                              ? `${parent.pprofit.ActualVsForecastVariance}%`
                              : `(${Math.abs(
                                  parent.pprofit.ActualVsForecastVariance,
                                )}%)`
                            : parent.pprofit.ActualVsBudgetVariance >= 0
                            ? `${parent.pprofit.ActualVsBudgetVariance}%`
                            : `(${Math.abs(
                                parent.pprofit.ActualVsBudgetVariance,
                              )}%)`}
                        </b>
                      </div>
                      <div
                        style={{
                          ...tableBorder,
                          backgroundColor: '#f7f7f7',
                          float: 'left',
                          width: '16.67%',
                        }}
                        onClick={(event) => {
                          handleElement(event, 'table');
                        }}
                      >
                        <b>
                          {parent.pprofit.YTDActual >= 0
                            ? `${parent.pprofit.YTDActual}%`
                            : `(${Math.abs(parent.pprofit.YTDActual)}%)`}
                        </b>
                      </div>
                      <div
                        style={{
                          ...tableBorder,
                          backgroundColor: '#f7f7f7',
                          float: 'left',
                          width: '16.67%',
                        }}
                        onClick={(event) => {
                          handleElement(event, 'table');
                        }}
                      >
                        <b>
                          {selectedOption === 'Forecast'
                            ? parent.pprofit.YTDForecast >= 0
                              ? `${parent.pprofit.YTDForecast}%`
                              : `(${Math.abs(parent.pprofit.YTDForecast)}%)`
                            : parent.pprofit.YTDBudget >= 0
                            ? `${parent.pprofit.YTDBudget}%`
                            : `(${Math.abs(parent.pprofit.YTDBudget)}%)`}
                        </b>
                      </div>
                      <div
                        style={{
                          ...tableBorder,
                          backgroundColor: '#f7f7f7',
                          float: 'left',
                          width: '16.65%',
                          color:
                            selectedOption === 'Forecast'
                              ? parent.pprofit.YTDActualVsForecastVariance > 0
                                ? '#389a38'
                                : 'black'
                              : parent.pprofit.YTDActualVsBudgetVariance > 0
                              ? '#389a38'
                              : 'black',
                        }}
                        onClick={(event) => {
                          handleElement(event, 'table');
                        }}
                      >
                        <b>
                          {selectedOption === 'Forecast'
                            ? parent.pprofit.YTDActualVsForecastVariance >= 0
                              ? `${parent.pprofit.YTDActualVsForecastVariance}%`
                              : `(${Math.abs(
                                  parent.pprofit.YTDActualVsForecastVariance,
                                )}%)`
                            : parent.pprofit.YTDActualVsBudgetVariance >= 0
                            ? `${parent.pprofit.YTDActualVsBudgetVariance}%`
                            : `(${Math.abs(
                                parent.pprofit.YTDActualVsBudgetVariance,
                              )}%)`}
                        </b>
                      </div>
                    </Grid>
                  </React.Fragment>
                );
              }
            })}

            <Grid size={12} style={{ height: 2 }}></Grid>

            {/* profit */}

            <Grid
              size={{ xs: 3 }}
              style={{
                ...tableBorder,
                borderTop: '1px solid lightgrey',
                justifyContent: 'start',
              }}
            >
              <TextField
                sx={{
                  height: 25,
                  '& .MuiInputBase-input': {
                    height: 25,
                    padding: 0,
                    fontWeight: 'bold',
                    fontSize: 12,
                    fontFamily: 'Verdana !important',
                  },
                  '.MuiOutlinedInput-notchedOutline': {
                    borderLeft: 'none',
                  },
                }}
                value={profitName}
                onChange={(e) => handleChangeProfitName(e, 'profit')}
                onBlur={() => handleSubmitProfitName('profit')}
                fullWidth
              />
            </Grid>
            <Grid container size={{ xs: 9 }} style={{ textAlign: 'center' }}>
              <div
                style={{
                  ...tableBorder,
                  borderTop: '1px solid lightgrey',
                  float: 'left',
                  width: '16.67%',
                }}
                onClick={(event) => {
                  handleElement(event, 'table');
                }}
              >
                <b>
                  {profit.incomeActual - profit.expenseActual >= 0
                    ? thousandFormat2(
                        profit.incomeActual - profit.expenseActual,
                      )
                    : `(${thousandFormat2(
                        Math.abs(profit.incomeActual - profit.expenseActual),
                      )})`}
                </b>
              </div>
              <div
                style={{
                  ...tableBorder,
                  borderTop: '1px solid lightgrey',
                  float: 'left',
                  width: '16.67%',
                }}
                onClick={(event) => {
                  handleElement(event, 'table');
                }}
              >
                <b>
                  {selectedOption === 'Forecast'
                    ? profit.incomeForecast - profit.expenseForecast >= 0
                      ? thousandFormat2(
                          profit.incomeForecast - profit.expenseForecast,
                        )
                      : `(${thousandFormat2(
                          Math.abs(
                            profit.incomeForecast - profit.expenseForecast,
                          ),
                        )})`
                    : profit.incomeBudget - profit.expenseBudget >= 0
                    ? thousandFormat2(
                        profit.incomeBudget - profit.expenseBudget,
                      )
                    : `(${thousandFormat2(
                        Math.abs(profit.incomeBudget - profit.expenseBudget),
                      )})`}
                </b>
              </div>
              <div
                style={{
                  ...tableBorder,
                  borderTop: '1px solid lightgrey',
                  float: 'left',
                  width: '16.67%',
                  color:
                    selectedOption === 'Forecast'
                      ? profit.incomeActualVsForecastVariance -
                          profit.expenseActualVsForecastVariance >
                        0
                        ? '#389a38'
                        : 'black'
                      : profit.incomeActualVsBudgetVariance -
                          profit.expenseActualVsBudgetVariance >
                        0
                      ? '#389a38'
                      : 'black',
                }}
                onClick={(event) => {
                  handleElement(event, 'table');
                }}
              >
                <b>
                  {selectedOption === 'Forecast'
                    ? profit.incomeActualVsForecastVariance -
                        profit.expenseActualVsForecastVariance >=
                      0
                      ? thousandFormat2(
                          profit.incomeActualVsForecastVariance -
                            profit.expenseActualVsForecastVariance,
                        )
                      : `(${thousandFormat2(
                          Math.abs(
                            profit.incomeActualVsForecastVariance -
                              profit.expenseActualVsForecastVariance,
                          ),
                        )})`
                    : profit.incomeActualVsBudgetVariance -
                        profit.expenseActualVsBudgetVariance >=
                      0
                      ? thousandFormat2(
                          profit.incomeActualVsBudgetVariance -
                            profit.expenseActualVsBudgetVariance,
                        )
                      : `(${thousandFormat2(
                          Math.abs(
                            profit.incomeActualVsBudgetVariance -
                              profit.expenseActualVsBudgetVariance,
                          ),
                        )})`}
                </b>
              </div>
              <div
                style={{
                  ...tableBorder,
                  borderTop: '1px solid lightgrey',
                  backgroundColor: '#f0f0f0',
                  float: 'left',
                  width: '16.67%',
                }}
                onClick={(event) => {
                  handleElement(event, 'table');
                }}
              >
                <b>
                  {profit.incomeYTDActual - profit.expenseYTDActual >= 0
                    ? thousandFormat2(
                        profit.incomeYTDActual - profit.expenseYTDActual,
                      )
                    : `(${thousandFormat2(
                        Math.abs(
                          profit.incomeYTDActual - profit.expenseYTDActual,
                        ),
                      )})`}
                </b>
              </div>
              <div
                style={{
                  ...tableBorder,
                  borderTop: '1px solid lightgrey',
                  backgroundColor: '#f0f0f0',
                  float: 'left',
                  width: '16.67%',
                }}
                onClick={(event) => {
                  handleElement(event, 'table');
                }}
              >
                <b>
                  {selectedOption === 'Forecast'
                    ? profit.incomeYTDForecast - profit.expenseYTDForecast >=
                        0
                      ? thousandFormat2(
                          profit.incomeYTDForecast -
                            profit.expenseYTDForecast,
                        )
                      : `(${thousandFormat2(
                          Math.abs(
                            profit.incomeYTDForecast -
                              profit.expenseYTDForecast,
                          ),
                        )})`
                    : profit.incomeYTDBudget - profit.expenseYTDBudget >= 0
                    ? thousandFormat2(
                        profit.incomeYTDBudget - profit.expenseYTDBudget,
                      )
                    : `(${thousandFormat2(
                        Math.abs(
                          profit.incomeYTDBudget - profit.expenseYTDBudget,
                        ),
                      )})`}
                </b>
              </div>
              <div
                style={{
                  ...tableBorder,
                  borderTop: '1px solid lightgrey',
                  backgroundColor: '#f0f0f0',
                  float: 'left',
                  width: '16.65%',
                  color:
                    selectedOption === 'Forecast'
                      ? profit.incomeYTDActualVsForecastVariance -
                          profit.expenseYTDActualVsForecastVariance >
                        0
                        ? '#389a38'
                        : 'black'
                      : profit.incomeYTDActualVsBudgetVariance -
                          profit.expenseYTDActualVsBudgetVariance >
                        0
                      ? '#389a38'
                      : 'black',
                }}
                onClick={(event) => {
                  handleElement(event, 'table');
                }}
              >
                <b>
                  {selectedOption === 'Forecast'
                    ? profit.incomeYTDActualVsForecastVariance -
                        profit.expenseYTDActualVsForecastVariance >=
                      0
                      ? thousandFormat2(
                          profit.incomeYTDActualVsForecastVariance -
                            profit.expenseYTDActualVsForecastVariance,
                        )
                      : `(${thousandFormat2(
                          Math.abs(
                            profit.incomeYTDActualVsForecastVariance -
                              profit.expenseYTDActualVsForecastVariance,
                          ),
                        )})`
                    : profit.incomeYTDActualVsBudgetVariance -
                        profit.expenseYTDActualVsBudgetVariance >=
                      0
                      ? thousandFormat2(
                          profit.incomeYTDActualVsBudgetVariance -
                            profit.expenseYTDActualVsBudgetVariance,
                        )
                      : `(${thousandFormat2(
                          Math.abs(
                            profit.incomeYTDActualVsBudgetVariance -
                              profit.expenseYTDActualVsBudgetVariance,
                          ),
                        )})`}
                </b>
              </div>
            </Grid>

            {/* %profit */}

            <Grid
              size={{ xs: 3 }}
              style={{
                ...tableBorder,
                backgroundColor: '#f7f7f7',
                justifyContent: 'start',
              }}
            >
              <TextField
                sx={{
                  height: 25,
                  '& .MuiInputBase-input': {
                    height: 25,
                    padding: 0,
                    fontWeight: 'bold',
                    fontSize: 12,
                    fontFamily: 'Verdana !important',
                  },
                  '.MuiOutlinedInput-notchedOutline': {
                    borderLeft: 'none',
                  },
                }}
                value={pprofitName}
                onChange={(e) => handleChangeProfitName(e, 'percent')}
                onBlur={() => handleSubmitProfitName('percent')}
                fullWidth
              />
            </Grid>
            <Grid container size={{ xs: 9 }} style={{ textAlign: 'center' }}>
              <div
                style={{
                  ...tableBorder,
                  backgroundColor: '#f7f7f7',
                  float: 'left',
                  width: '16.67%',
                }}
                onClick={(event) => {
                  handleElement(event, 'table');
                }}
              >
                <b>
                  {pprofit.Actual >= 0
                    ? `${pprofit.Actual}%`
                    : `(${Math.abs(pprofit.Actual)}%)`}
                </b>
              </div>
              <div
                style={{
                  ...tableBorder,
                  backgroundColor: '#f7f7f7',
                  float: 'left',
                  width: '16.67%',
                }}
                onClick={(event) => {
                  handleElement(event, 'table');
                }}
              >
                <b>
                  {selectedOption === 'Forecast'
                    ? pprofit.Forecast >= 0
                      ? `${pprofit.Forecast}%`
                      : `(${Math.abs(pprofit.Forecast)}%)`
                    : pprofit.Budget >= 0
                    ? `${pprofit.Budget}%`
                    : `(${Math.abs(pprofit.Budget)}%)`}
                </b>
              </div>
              <div
                style={{
                  ...tableBorder,
                  backgroundColor: '#f7f7f7',
                  float: 'left',
                  width: '16.67%',
                  color:
                    selectedOption === 'Forecast'
                      ? pprofit.ActualVsForecastVariance > 0
                        ? '#389a38'
                        : 'black'
                      : pprofit.ActualVsBudgetVariance > 0
                      ? '#389a38'
                      : 'black',
                }}
                onClick={(event) => {
                  handleElement(event, 'table');
                }}
              >
                <b>
                  {selectedOption === 'Forecast'
                    ? pprofit.ActualVsForecastVariance >= 0
                      ? `${pprofit.ActualVsForecastVariance}%`
                      : `(${Math.abs(pprofit.ActualVsForecastVariance)}%)`
                    : pprofit.ActualVsBudgetVariance >= 0
                    ? `${pprofit.ActualVsBudgetVariance}%`
                    : `(${Math.abs(pprofit.ActualVsBudgetVariance)}%)`}
                </b>
              </div>
              <div
                style={{
                  ...tableBorder,
                  backgroundColor: '#f7f7f7',
                  float: 'left',
                  width: '16.67%',
                }}
                onClick={(event) => {
                  handleElement(event, 'table');
                }}
              >
                <b>
                  {pprofit.YTDActual >= 0
                    ? `${pprofit.YTDActual}%`
                    : `(${Math.abs(pprofit.YTDActual)}%)`}
                </b>
              </div>
              <div
                style={{
                  ...tableBorder,
                  backgroundColor: '#f7f7f7',
                  float: 'left',
                  width: '16.67%',
                }}
                onClick={(event) => {
                  handleElement(event, 'table');
                }}
              >
                <b>
                  {selectedOption === 'Forecast'
                    ? pprofit.YTDForecast >= 0
                      ? `${pprofit.YTDForecast}%`
                      : `(${Math.abs(pprofit.YTDForecast)}%)`
                    : pprofit.YTDBudget >= 0
                    ? `${pprofit.YTDBudget}%`
                    : `(${Math.abs(pprofit.YTDBudget)}%)`}
                </b>
              </div>
              <div
                style={{
                  ...tableBorder,
                  backgroundColor: '#f7f7f7',
                  float: 'left',
                  width: '16.65%',
                  color:
                    selectedOption === 'Forecast'
                      ? pprofit.YTDActualVsForecastVariance > 0
                        ? '#389a38'
                        : 'black'
                      : pprofit.YTDActualVsBudgetVariance > 0
                      ? '#389a38'
                      : 'black',
                }}
                onClick={(event) => {
                  handleElement(event, 'table');
                }}
              >
                <b>
                  {selectedOption === 'Forecast'
                    ? pprofit.YTDActualVsForecastVariance >= 0
                      ? `${pprofit.YTDActualVsForecastVariance}%`
                      : `(${Math.abs(pprofit.YTDActualVsForecastVariance)}%)`
                    : pprofit.YTDActualVsBudgetVariance >= 0
                    ? `${pprofit.YTDActualVsBudgetVariance}%`
                    : `(${Math.abs(pprofit.YTDActualVsBudgetVariance)}%)`}
                </b>
              </div>
            </Grid>
          </Grid>
        </div>
      ) : (
        <div style={empty(200)} className="well">
          No data
        </div>
      )}
    </div>
  );
};

BottomChart.propTypes = {
  detailData: PropTypes.array.isRequired,
  handleFilter: PropTypes.func.isRequired,
  selectedOption: PropTypes.string.isRequired,
  showPercent: PropTypes.bool.isRequired,
  profitName: PropTypes.string.isRequired,
  pprofitName: PropTypes.string.isRequired,
};

export default BottomChart;
